module.exports = __webpack_public_path__ + "2bab0a0f43354a6a551d9f206679aecf.pdf";